import { render, staticRenderFns } from "./PermissionObjectType.vue?vue&type=template&id=d1c010f0&scoped=true"
import script from "./PermissionObjectType.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionObjectType.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PermissionObjectType.vue?vue&type=style&index=0&id=d1c010f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c010f0",
  null
  
)

export default component.exports